import { FieldRenderProps, FieldWrapper } from "@progress/kendo-react-form";
import { Error, Label } from "@progress/kendo-react-labels";
import { useRef } from "react";
import CanopyDateRangePicker from "../functional/CanopyDateRangePicker";

export const FormDateRangePicker = (fieldRenderProps: FieldRenderProps) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    wrapperStyle,
    ...others
  } = fieldRenderProps;
  const editorRef = useRef<any>(null);

  const showValidationMessage: string | false | null = touched && validationMessage;
  const showHint: boolean = !showValidationMessage && hint;
  const hintId: string = showHint ? `${id}_hint` : "";
  const errorId: string = showValidationMessage ? `${id}_error` : "";
  const labelId: string = label ? `${id}_label` : "";

  return (
    <FieldWrapper style={wrapperStyle}>
      <Label
        id={labelId}
        editorRef={editorRef}
        editorId={id}
        editorValid={valid}
        editorDisabled={disabled}
      >
        {label}
      </Label>
      <CanopyDateRangePicker
        ariaLabelledBy={labelId}
        ariaDescribedBy={`${hintId} ${errorId}`}
        innerRef={editorRef}
        valid={valid}
        id={id}
        disabled={disabled}
        {...others}
      />
      {/* {showHint && <Hint id={hint Id}>{hint}</Hint>} */}
      {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
    </FieldWrapper>
  );
};
